'use client';

import { APIProvider, Map, type MapProps } from '@vis.gl/react-google-maps';
import { env } from '@/env';

const mapDefaults: MapProps = {
    defaultZoom: 15,
    defaultCenter: { lat: -36.8406, lng: 174.74 },
    mapTypeId: 'roadmap',
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
};

export type GoogleMapProps = MapProps;

export function GoogleMap({ className, children, ...props }: GoogleMapProps) {
    if (!env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY) {
        throw new Error('NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is not set');
    }
    if (!env.NEXT_PUBLIC_GOOGLE_MAP_ID) {
        throw new Error('NEXT_PUBLIC_GOOGLE_MAP_ID is not set');
    }

    return (
        <APIProvider apiKey={env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}>
            <Map mapId={env.NEXT_PUBLIC_GOOGLE_MAP_ID} className={className} {...mapDefaults} {...props}>
                {children}
            </Map>
        </APIProvider>
    );
}
